import { Select } from '@mantine/core'
import type { TLngLat } from 'App/Map/types'
import { translate } from 'i18n/i18n'
import { hubConnectorSettings } from 'settings/hubConnectorSettings'
import { SharedSettings } from 'settings/SharedSettings'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { mantineSelectSearchFilterProp } from 'utils/mantineSelectSearchFilterProp'
import { sortByKey } from 'utils/sortByKey'

export const StationSelect = ({
  selectedStation,
  onStationChange,
}: {
  selectedStation: TLngLat | null
  onStationChange: (value: TLngLat) => void
}) => {
  const properties = fieldAssetStore.useSelector((s) => s.properties)

  const stationOptions: {
    value: string
    label: string
    group: string
  }[] = Object.values(properties ?? {})
    .flatMap((property) => {
      if (!property.points) return []

      return Object.entries(property.points)
        .filter(([, point]) => point.configuration?.soilProbeDepthsAvailable?.length)
        .map(([lngLat, point]) => ({
          value: lngLat,
          label: point.name,
          group: property.propertyName,
        }))
    })
    .sort(sortByKey('label'))
    .sort(sortByKey('group'))

  return (
    <Select
      clearable={false}
      w={300}
      onChange={(value) => value && onStationChange(value as TLngLat)}
      data={stationOptions}
      placeholder={translate.phrases.banyanApp('Select a Station')}
      filter={mantineSelectSearchFilterProp}
      searchable
      size="xs"
      spellCheck="false"
      styles={{
        ...SharedSettings.MANTINE_SELECT_RIGHT_ICON_CHANGER,
        ...SharedSettings.MANTINE_SELECT_UNDERLINE_SEPARATOR_STYLES,
        dropdown: { marginTop: -6, fontWeight: 'normal' },
        input: { ...SharedSettings.MANTINE_SELECT_RIGHT_ICON_CHANGER.input, paddingRight: 28 },
      }}
      value={selectedStation}
      withinPortal
      zIndex={hubConnectorSettings.zIndexForDropdownSelectorInStackemCharts + 10000}
    />
  )
}
